const initialServiceState = [];

export const serviceReducer = (state = initialServiceState, action) => {
  switch (action.type) {
    case 'SET_SERVICES':
      return action.payload;
    default:
      return state;
  }
};

const initialTeacherState = [];

export const teacherReducer = (state = initialTeacherState, action) => {
  switch (action.type) {
    case 'SET_TEACHERS':
      return action.payload;
    default:
      return state;
  }
};